// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Our soul has had more than enough of the scorn of the arrogant,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and of the contempt of the proud.<br> </p> </div></div>";
// Exports
module.exports = code;